import { landingFetchDonorMe } from '@/lib/landing-auth'

const LANDING_DONOR_SESSION_FLAG = 'legalprime:landingDonorSession'
const SESSION_MARKER = 'cookie'
let inMemorySession = false

export function readLandingDonorToken(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage.getItem(LANDING_DONOR_SESSION_FLAG) === '1'
      ? SESSION_MARKER
      : null
  } catch {
    return inMemorySession ? SESSION_MARKER : null
  }
}

export function writeLandingDonorToken(token: string | null): void {
  if (typeof window === 'undefined') return

  inMemorySession = Boolean(token)
  try {
    if (token) {
      window.localStorage.setItem(LANDING_DONOR_SESSION_FLAG, '1')
      return
    }

    window.localStorage.removeItem(LANDING_DONOR_SESSION_FLAG)
  } catch {
    // Storage can be unavailable in mobile private/in-app browsers.
    // Authentication still belongs to the server's HttpOnly cookie.
  }
}

export function clearLandingDonorSessionIfUnauthorized(status: number): void {
  if (status === 401) {
    writeLandingDonorToken(null)
  }
}

/**
 * Confirma que o cookie httpOnly está ativo via GET /api/donor/me antes de marcar a sessão no SPA.
 */
export async function establishLandingDonorSession(): Promise<boolean> {
  try {
    await landingFetchDonorMe(SESSION_MARKER)
    writeLandingDonorToken(SESSION_MARKER)
    return true
  } catch {
    writeLandingDonorToken(null)
    return false
  }
}
